import CategoryManagement from "./Components/CategoryManagement";
import ProductManagement from "./Components/ProductManagement";
import UserManagement from "./Components/UserManagement";
import ExtraManagement from "./Components/ExtraManagement";
import DiscountManagement from "./Components/DiscountManagement";
import { useModal } from "../../../Components/Modal";
import EditWorkspace from "./Components/EditWorkspace";
import OfferManagement from "./Components/OfferManagement";
import IndexPage from "../../Crud/IndexPage";
import EditSubscriptionForm from "./Forms/EditSubscriptionForm";
import { CashRegisterEntryManagement } from "./Components/CashRegisterEntryManagement";
import SubscriptionHelper from "../../../Helper/SubscriptionHelper";
import TimeTrackingManagement from "./Components/TimeTrackingManagement";
import TimeTrackingReportManagement from "./Components/TimeTrackingReportManagement";

const WorkspaceManagement = () => {
    /* Modal Loader */
    const { ModalView, openModal, closeModal } = useModal()

    const {isAllowed, hasActive} = SubscriptionHelper()

    return (
        <>
            <IndexPage title="Einstellungen"
                items={[
                    { text: "Kategorien verwalten", icon: "category", action: () => openModal(<CategoryManagement />) },
                    { text: "Produkte verwalten", icon: "carrot", action: () => openModal(<ProductManagement />) },
                    { text: "Extras verwalten", icon: "plus", action: () => openModal(<ExtraManagement />) },
                    { text: "Rabatte verwalten", icon: "discount", action: () => openModal(<DiscountManagement />) },
                    { text: "Coupons verwalten", icon: "qrcode", action: () => openModal(<OfferManagement />) },
                    { text: "Mitarbeiter verwalten", icon: "users-group", action: () => openModal(<UserManagement />) },
                    isAllowed("allowCashierUserTracking") && hasActive("cashierUserTracking") && { text: "Kassenabrechnungen verwalten", icon: "invoice", action: () => openModal(<CashRegisterEntryManagement />) },
                    isAllowed("allowTimeTracking") && hasActive("useTimeTracking") && { text: "Stempelzeiten verwalten", icon: "clock-check", action: () => openModal(<TimeTrackingManagement />) },
                    isAllowed("allowTimeTracking") && hasActive("useTimeTracking") && { text: "Mitarbeiter Stempelzeiten", icon: "clock-check", action: () => openModal(<TimeTrackingReportManagement />) },
                    { text: "Workspace verwalten", icon: "building-store", role: "OWNER", action: () => openModal(<EditWorkspace afterAction={() => closeModal()} />) },
                    { text: "Abo verwalten", icon: "brand-stripe", role: "OWNER", action: () => openModal(<EditSubscriptionForm afterAction={() => closeModal()} />) }
                ]}
            />
            <ModalView classNames="w-[600px] max-w-full h-full" />
        </>
    );
}

export default WorkspaceManagement;